import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M17.25 22H13.25V20.5H17.25C17.939 20.5 18.5 19.939 18.5 19.25V4.75C18.5 4.061 17.939 3.5 17.25 3.5H9.25C8.561 3.5 8 4.061 8 4.75V8H6.5V4.75C6.5 3.233 7.733 2 9.25 2H17.25C18.767 2 20 3.233 20 4.75V19.25C20 20.767 18.767 22 17.25 22ZM12 19.75C12 20.99 10.991 22 9.75 22H6.25C5.009 22 4 20.99 4 19.75V11.75C4 10.509 5.009 9.5 6.25 9.5H9.75C10.991 9.5 12 10.509 12 11.75V19.75ZM6.25 11C5.836 11 5.5 11.336 5.5 11.75V19.75C5.5 20.163 5.836 20.5 6.25 20.5H9.75C10.164 20.5 10.5 20.163 10.5 19.75V11.75C10.5 11.336 10.164 11 9.75 11H6.25ZM7.5 12.75C7.362 12.75 7.25 12.638 7.25 12.5C7.25 12.362 7.362 12.25 7.5 12.25H8.5C8.638 12.25 8.75 12.362 8.75 12.5C8.75 12.638 8.638 12.75 8.5 12.75H7.5ZM8.5 19C8.5 19.2761 8.27614 19.5 8 19.5C7.72386 19.5 7.5 19.2761 7.5 19C7.5 18.7239 7.72386 18.5 8 18.5C8.27614 18.5 8.5 18.7239 8.5 19ZM13.75 19C13.75 19.2761 13.5261 19.5 13.25 19.5C12.9739 19.5 12.75 19.2761 12.75 19C12.75 18.7239 12.9739 18.5 13.25 18.5C13.5261 18.5 13.75 18.7239 13.75 19Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'Devices');

export default Icon;
